import TilesetMenu from './TilesetMenu';
import { isSuitabilityTileset } from '../../utils/tilesets';
import { TILESET_TYPE_CROP } from '../../types/tileset';

export const SUITABILITY_LAYER_ID = 'suitability';

const SuitabilityMenu = () => (
  <TilesetMenu filterTilesets={isSuitabilityTileset} type={TILESET_TYPE_CROP} />
);

export default SuitabilityMenu;
